import React from "react";
import { RoutePath } from "../../routes";
import { RestrictedLink } from "../../routes";
import { useLocation } from "react-router-dom";
import "./HeaderMenuItem.scoped.scss";

interface Props {
  path: RoutePath;
  description: string;
  imageSource: string;
  imageHoverSource: string;
}

export default function HeaderMenuItem(props: Props) {
  const location = useLocation();
  const [currentImage, setCurrentImage] = React.useState(props.imageSource);

  return (
    <RestrictedLink to={props.path}>
      <img
        className="HeaderMenu-Button"
        src={
          location.pathname === props.path
            ? props.imageHoverSource
            : currentImage
        }
        alt={props.description}
        onMouseEnter={() => setCurrentImage(props.imageHoverSource)}
        onMouseLeave={() => setCurrentImage(props.imageSource)}
        onTouchStart={() => setCurrentImage(props.imageHoverSource)}
        onTouchEnd={() => setCurrentImage(props.imageSource)}
        onTouchCancel={() => setCurrentImage(props.imageSource)}
      />
    </RestrictedLink>
  );
}
